import React from "react";
import Icon from "components/elements/Icon";

import ArchidektDropdown from "components/elements/ArchidektDropdown";

import styles from "./dropdown.module.scss";

export type Option = {
  label: React.ReactNode;
  value: any;
};

type Props = {
  id?: string;
  value: any;
  options: Option[];
  onChange: (selectedOption: any) => void;
  wrapperClassName?: string;
  menuClassName?: string;
  triggerClassName?: string;
  labelClassName?: string;
  trigger?: React.ReactNode;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
  noIcon?: boolean;
};

const Dropdown = ({
  id,
  value,
  options,
  onChange,
  trigger = null,
  menuClassName,
  triggerClassName,
  wrapperClassName,
  labelClassName,
  disabled,
  label,
  placeholder,
  noIcon,
}: Props) => (
  <ArchidektDropdown
    disabled={disabled}
    triggerClassName={wrapperClassName}
    menuClassName={menuClassName}
    options={options.map((o) => ({ label: o.label, onClick: () => onChange(o.value) }))}
  >
    {label && (
      <label className={styles.labelClassName} htmlFor={id}>
        {label}
      </label>
    )}
    {trigger || (
      <button id={id} className={`${styles.trigger} ${triggerClassName}`} disabled={disabled}>
        {options.find((o) => o.value === value)?.label || value || placeholder}
        {!noIcon && <Icon name="triangle down" />}
      </button>
    )}
  </ArchidektDropdown>
);

export default Dropdown;
